<template>
  <div>
    <span>
      <colour-picker v-model="colour" v-if="colour !== null"></colour-picker>
    </span>
    <div class="options">
      <div>
        <button class="button" :class="{'is-primary': bold}" @click="bold = !bold"><span class="icon"><i class="fal fa-bold"></i></span></button>
        <button class="button" :class="{'is-primary': italic}" @click="italic = !italic"><span class="icon"><i class="fal fa-italic"></i></span></button>
        <button class="button" :class="{'is-primary': underline}" @click="underline = !underline"><span class="icon"><i class="fal fa-underline"></i></span></button>
      </div>
      <div>
        <label>{{ $t('magicboard.size') }}</label>
        <select class="select" v-model="size">
          <option v-for="s in sizes" :key="s">{{s}}</option>
        </select>
      </div>
      <div>
        <button class="button" :class="{'is-primary': align === 'left'}" @click="align = 'left'"><span class="icon"><i class="fal fa-align-left"></i></span></button>
        <button class="button" :class="{'is-primary': align === 'center'}" @click="align = 'center'"><span class="icon"><i class="fal fa-align-center"></i></span></button>
        <button class="button" :class="{'is-primary': align === 'right'}" @click="align = 'right'"><span class="icon"><i class="fal fa-align-right"></i></span></button>
      </div>
      <div class="serifs is-flex">
        <label>{{ $t('magicboard.serif') }} </label>
        <button class="button serif" :class="{'is-primary': serif}" @click="serif = true">T</button>
        <button class="button sans-serif"  :class="{'is-primary': !serif}" @click="serif = false">T</button>
      </div>
    </div>
  </div>
</template>

<script>
import ColourPicker from './ColourPicker'

export default {
  props: ['settings'],
  components: {
    ColourPicker
  },
  data: function () {
    return {
      colour: null,
      bold: false,
      italic: false,
      underline: false,
      serif: false,
      size: 20,
      sizes: [5, 10, 20, 30, 40, 50, 75, 100],
      align: 'center'
    }
  },
  mounted: function () {
    this.colour = this.settings.colour
    this.bold = this.settings.bold
    this.italic = this.settings.italic
    this.underline = this.settings.underline
    this.size = this.settings.size
    this.serif = this.settings.serif
    this.align = this.settings.align
  },
  methods: {
    title: function () {
      return 'Text Settings'
    },
    update: function () {
      this.settings.colour = this.colour
      this.settings.bold = this.bold
      this.settings.italic = this.italic
      this.settings.underline = this.underline
      this.settings.size = this.size
      this.settings.serif = this.serif
      this.settings.align = this.align
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  .modal-card-body {
    padding: 2%;
  }

  .options {
    margin: 2% auto;
    padding: 0 0.75rem 0 0.5rem;
    text-align: center;
    display: flex;
    justify-content: space-between;

    @include mobile {
      flex-wrap: wrap;
      padding-top: 0.25rem;
      padding-bottom: 0;
      margin-bottom: 0;

      & > div {
        flex-basis: 50%;
        margin-bottom: 0.5rem;

        &:nth-child(even) {
          text-align: right;
        }

        &:nth-child(odd) {
          text-align: left;
        }
      }
    }
  }

  .serifs {
    justify-content: space-between;
    align-items: center;
    width: 120px;
    max-width: 125px;
  }

  .serif {
    font-family: 'Times New Roman', Times, serif;
  }

  .sans-serif {
    font-family: Arial, Helvetica, sans-serif;
  }

  .serif, .sans-serif {
    font-size: 1.6rem;
    padding: 0.5rem;
    height: 2rem;
    line-height: 1rem;
  }
</style>
